// removed by extract-text-webpack-plugin
module.exports = {"inputGroup":"_3u7bU2KzEiEGvOSKHOCHg4","label":"KlfyUfSb0pF1LVwTNfl5M"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/form-elements/checkbox.scss
// module id = 79
// module chunks = 0